/**
 * I3 — totaux détail commande (admin) : éviter double déduction
 * (total déjà post-indispo + remboursement Stripe).
 */

/**
 * @param {{ total?: number|null, totalRefund?: number|null, netFromPayments?: number|null }} input
 * @returns {{ orderTotal: number, hasRefund: boolean, totalRefund: number, netTotal: number, strikeTotal: boolean }}
 */
export function resolveCommandeDetailTotals(input = {}) {
  const orderTotal = Math.round((Number(input.total) || 0) * 100) / 100;
  const totalRefund = Math.round((Number(input.totalRefund) || 0) * 100) / 100;
  const hasRefund = totalRefund > 0.005;
  const netFromPayments = Number(input.netFromPayments);
  const netTotal =
    hasRefund && Number.isFinite(netFromPayments)
      ? Math.round(netFromPayments * 100) / 100
      : orderTotal;
  // Barrer le total seulement s'il représente encore le montant avant remboursement
  // (ex. 34,90 barré → net 19). Après I1, total déjà à 19 → ne pas barrer ni re-soustraire.
  const strikeTotal =
    hasRefund && Math.abs(orderTotal - (netTotal + totalRefund)) < 0.02;
  return {
    orderTotal,
    hasRefund,
    totalRefund,
    netTotal,
    strikeTotal,
  };
}
